<template>
  <div>
    <CCard>
      <CCardBody>
        <CButton @click="cadastrar()" style="width: 100px" block color="primary"
          >Cadastrar</CButton
        >
      </CCardBody>
    </CCard>

    <CCard>
      <CCardBody>
        <CDataTable
          :items="convenios"
          :fields="fields"
          :noItemsView="not_found"
          column-filter
          hover
          sorter
          small
          :fixed="fixed"
          :items-per-page="5"
          :dark="dark"
          pagination
        >
          <template #acao="{ item, index }">
            <td class="py-4">
              <CButton
                color="primary"
                variant="outline"
                square
                size="sm"
                @click="editar(item, index)"
                >VER</CButton
              >
            </td>
            <td class="py-4">
              <CButton
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="excluir(item, index)"
                >EXCLUIR</CButton
              >
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
export default {
  name: "ListarConvenios",
  data() {
    return {
      desativado: false,
      not_found: {
        noResults: "Nenhum registro encontrado",
        noItems: "Nenhum registro encontrado",
      },
      convenios: [],
      fields: [
        { key: "name", label: "Nome", _style: "min-width:200px" },
        { key: "crp", label: "CRP", _style: "min-width:100px" },
        {
          key: "particular",
          label: "Particular",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "saude_caixa",
          label: "Saúde Caixa",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "cassi",
          label: "Cassi",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "bradesco",
          label: "Bradesco",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "unimed",
          label: "Unimed",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "particular_805",
          label: "Particular 805",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "saude_pas",
          label: "Saúde pas",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "palestra",
          label: "Palestra",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "supervisao",
          label: "Supervisao",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "socialize",
          label: "Socialize",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "proap",
          label: "Proap",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "golden_cross",
          label: "Golden Cross",
          _style: "min-width:40px;",
        },
        {
          key: "acao",
          label: "",
          sorter: false,
          filter: false,
        },
      ],
      collapseDuration: 0,
      details: [],
      usuario: {
        id: localStorage.id,
        tipo: localStorage.tipo,
      },
      caption: {
        type: String,
        default: "Table",
      },
      hover: true,
      striped: true,
      bordered: false,
      small: true,
      fixed: true,
      dark: false,
    };
  },
  methods: {
    listarConvenios() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}lista-convenios`)
        .then((res) => res.json())
        .then((res) => {
          this.convenios = res;
        });
    },

    excluir(item) {
      this.$http
        .delete(
          `${process.env.VUE_APP_API_BASE_URL}convenios/excluir-convenio/${item.id}`
        )
        .then((res) => res.json())
        .then((res) => {
          this.sucesso = true;
          this.listarConvenios();
        });
    },
  },

  mounted() {
    this.listarConvenios();
  },
};
</script>
<style scoped></style>
